import React from 'react';
import PropTypes from 'prop-types';

import 'AppSrc/core/style/components/form/section-nav.css';

const navigationPropsShape = PropTypes.shape({
  cancel: PropTypes.func,
  next: PropTypes.func,
  prev: PropTypes.func,
  saveChanges: PropTypes.bool,
  submitForm: PropTypes.func,
});

const SectionNav = React.memo(({
  navigationProps,
  handleSubmit,
  readyToSubmit,
  sectionId,
  statusReason,
  status,
}) => {

  const {
    cancel,
    next,
    prev,
    saveChanges,
    submitForm,
  } = navigationProps;

  const isRelationship = (sectionId === 'RELATIONSHIPS' && (statusReason === 'PostponedCRQ' || statusReason === '30300') && status === '3') ? true : false;

  return (
    <>
      {/* When we do a stick to bottum situation we will probably need this. It's too difficult to implement now though */}
      <div className="form-nav-section form-nav-section-spacemaker" />
      <div className="form-nav-section">
        <div className="side-left">
          {
            prev && (
              <button
                type="button"
                className="prev-button"
                onClick={prev}
              >
                Back
              </button>
            )
          }
          {
            cancel && (
              <button
                type="button"
                className="cancel-button"
                onClick={cancel}
              >
                {isRelationship ? 'Back' : 'Cancel'}
              </button>
            )
          }
        </div>
        <div className="side-right">
          {
            next && (
              <button
                type="submit"
                className={`next-button next-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                // whilst handleSubmit saves the form and also checks on a TLC bases where to navigate
                onClick={next}
              >
                Next
              </button>
            )
          }
          {
            saveChanges && (
              <button
                type="submit"
                className={`submit-button submit-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                // whilst handleSubmit saves the form and also checks on a TLC bases where to navigate
                onClick={handleSubmit}
              >
                Save changes
              </button>
            )
          }
          {
            submitForm && (
              <button
                type="submit"
                className={`submit-button submit-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                onClick={submitForm}
              >
                Submit
              </button>
            )
          }
        </div>
      </div>
    </>
  );
});


SectionNav.propTypes = {
  navigationProps: navigationPropsShape,
  handleSubmit: PropTypes.func,
  readyToSubmit: PropTypes.bool,
  next: PropTypes.bool,
  prev: PropTypes.func,
  submitForm: PropTypes.func,
  sectionId: PropTypes.string,
  statusReason: PropTypes.string,
  status: PropTypes.string,
};

export {
  SectionNav,
  navigationPropsShape,
};
